export const PAYMENT_SUCCESS_BILL_DETAILS = {
    ORDER_ID: "order-id",
    BILL_DETAILS: "bill-details",
    BILL_DETAIL_ITEM: {
        LEFT_TEXT: "left-text",
        RIGHT_TEXT: "right-text",
        STRIKED_TEXT: "striked-text",
    },
    billAmount: "billAmount",
};
